//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList as theaterList } from "@/api/PMS/performancecenter/theater"; // import { fetchList as DeveiceList } from '@/api/system/device/device'

import { fetchCreate, fetchUpdate, fetchDetail } from "@/api/PMS/performancecenter/theaterManageDetail"; // import { fetchCreate, fetchUpdate, fetchDetail } from "@/api/PMS/performancecenter/theaterArea";

export default {
  props: ['keyValue', 'showDialog', 'activityManageId'],
  data: function data() {
    return {
      rules: {
        itemName: [{
          required: true,
          message: '请输入场次名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        // deviceId: [{ required: true, message: '请选择所属设备', trigger: 'blur' }
        // ],
        maxRegNum: [{
          required: true,
          message: '请输入最大报名人数',
          trigger: 'blur'
        }],
        theaterId: [{
          required: true,
          message: '请选择所属剧院',
          trigger: 'blur'
        }]
      },
      theaterOption: [],
      childData: {
        itemName: '',
        // deviceId: '',
        maxRegNum: '',
        theaterId: ''
      }
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });
      this.getTheaterList();

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {
          itemName: '',
          // deviceId: '',
          maxRegNum: '',
          theaterId: ''
        };
      }
    },
    getTheaterList: function getTheaterList() {
      var _this2 = this;

      theaterList({}).then(function (response) {
        _this2.theaterOption = response.data.data;
      });
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this3.$set(_this3.childData, "activityManageId", _this3.activityManageId);

          if (_this3.keyValue > 0) {
            fetchUpdate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'update'
                });
              }
            });
          } else {
            fetchCreate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};